import { useListSchoolDepartmentsLazyQuery } from '@/types/vue-apollo-helpers';

export const useDepartment = ({
  autoFetch = false,
}: { autoFetch?: boolean; onResultHandler?: () => void }) => {
  const { result: schoolDepartmentResult,
    loading: loadingSchoolDepartment,
    refetch: refetchSchoolDepartment,
    load: loadSchoolDepartment,
    error: errorSchoolDepartment,
    onResult: onResultSchoolDepartment,
  } = useListSchoolDepartmentsLazyQuery();
  if (autoFetch) loadSchoolDepartment();

  const departments = computed(() => schoolDepartmentResult.value?.listSchoolDepartments);

  return {
    departments,
    loadingSchoolDepartment,
    loadSchoolDepartment,
    refetchSchoolDepartment,
    errorSchoolDepartment,
    onResultSchoolDepartment,
  };
};
